<template lang="pug">
  .hook-error
    .section
      .container
        .columns
          .column
            .block-center(v-if="!success")
              h2 {{ gettext('Error!') }}
              h3 {{ gettext('An error occurred while verifying email, contact with support, or try again later.') }}
              .field
                .field-body
                  router-link.main-btn.col-white.bg-red(:to="`/${getLanguage}/`") {{ gettext('Go to the main page') }}
            .block-center(v-if="(success && !employer) || (employer && !mustBeValidate)")
              h2 {{ gettext('Congratulations!') }}
              h3 {{ gettext('You are successfully registered, now you can log in.') }}
              .field
                .field-body
                  router-link.main-btn.col-white.bg-red(:to="{name: 'Login', params: {lang: getLanguage}}") {{ gettext('Login') }}
            .block-center(v-if="success && employer && mustBeValidate")
              h2 {{ gettext('Thank you!') }}
              h3 {{ gettext('After verifying your data, a notification with a registration status will be sent to your email address.') }}
              .field
                .field-body
                  router-link.main-btn.col-white.bg-red(:to="{name: 'Home', params: {lang: getLanguage}}") {{ gettext('Home') }}
</template>

<script>
import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'

export default {
  name: 'RegistrationEmailVerification',
  data () {
    return {
      success: this.$route.query.success === '1',
      mustBeValidate: this.$route.query.must_be_validated_manually === '1'
    }
  },
  props: {
    employer: {
      default: false
    }
  },
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  }
}
</script>

<style scoped lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/pages/hooks/registration-email-verification/index.vue